import React, { Component } from 'react'
import './index.less'

export default class extends Component {
  ruleContentTxt = () => {
    const { ruleContent: config, language } = this.props
    if (language == 'ar') {
      return config.ruleContentAr
    }
    else if (language == 'en') {
      return config.ruleContent
    }
    else if (language == 'tr') {
      return config.ruleContentTr
    }
    else if (language == 'zh') {
      return config.ruleContentZh
    }
    else if (language == 'jp') {
      return config.ruleContentJp
    }
  }

  render() {
    // 主题
    const { titleBg, topBg, centerBg, bottomBg } = this.props
    // 状态
    const { isShowRule, ruleTitle, ruleContent, language } = this.props
    // 方法
    const { onChangeRule } = this.props

    return (
      <div className="nt-rule-main" style={{ display: `${isShowRule ? 'block' : 'none'}` }} onClick={() => onChangeRule(false)}>
        {/* 内容 */}
        <div className={`nt-rule-wrap ${isShowRule ? 'nt-rule-active' : ''}`} style={{ backgroundImage: `url(${centerBg})` }}>
          {/* 头部背景 */}
          <div className="nt-top-bg" style={{ backgroundImage: `url(${topBg})` }}></div>
          {/* 尾部背景 */}
          <div className="nt-bottom-bg" style={{ backgroundImage: `url(${bottomBg})` }}></div>
          <div className="nt-rule-title" style={{ backgroundImage: `url(${titleBg})` }}>{ruleTitle}</div>
          <div className="nt-rule-content">
            <div className="content" dangerouslySetInnerHTML={{ __html: this.ruleContentTxt() || '' }}>
            </div>
          </div>
        </div>
        <div className="nt-mask"></div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/activity/nationalTemplate/Rule/index.js